"use strict";

require("core-js/modules/es.regexp.exec.js");

require("core-js/modules/es.string.split.js");

require("core-js/modules/es.number.constructor.js");

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/es.typed-array.uint32-array.js");

require("core-js/modules/es.typed-array.at.js");

require("core-js/modules/es.typed-array.copy-within.js");

require("core-js/modules/es.typed-array.every.js");

require("core-js/modules/es.typed-array.fill.js");

require("core-js/modules/es.typed-array.filter.js");

require("core-js/modules/es.typed-array.find.js");

require("core-js/modules/es.typed-array.find-index.js");

require("core-js/modules/es.typed-array.for-each.js");

require("core-js/modules/es.typed-array.includes.js");

require("core-js/modules/es.typed-array.index-of.js");

require("core-js/modules/es.typed-array.iterator.js");

require("core-js/modules/es.typed-array.join.js");

require("core-js/modules/es.typed-array.last-index-of.js");

require("core-js/modules/es.typed-array.map.js");

require("core-js/modules/es.typed-array.reduce.js");

require("core-js/modules/es.typed-array.reduce-right.js");

require("core-js/modules/es.typed-array.reverse.js");

require("core-js/modules/es.typed-array.set.js");

require("core-js/modules/es.typed-array.slice.js");

require("core-js/modules/es.typed-array.some.js");

require("core-js/modules/es.typed-array.sort.js");

require("core-js/modules/es.typed-array.subarray.js");

require("core-js/modules/es.typed-array.to-locale-string.js");

require("core-js/modules/es.typed-array.to-string.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.add5H = exports.add5L = exports.add4H = exports.add4L = exports.add3H = exports.add3L = exports.add = exports.rotlBL = exports.rotlBH = exports.rotlSL = exports.rotlSH = exports.rotr32L = exports.rotr32H = exports.rotrBL = exports.rotrBH = exports.rotrSL = exports.rotrSH = exports.shrSL = exports.shrSH = exports.toBig = exports.split = exports.fromBig = void 0;
var U32_MASK64 = BigInt(Math.pow(2, 32) - 1);

var _32n = BigInt(32);

function fromBig(n) {
  var le = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  if (le) return {
    h: Number(n & U32_MASK64),
    l: Number(n >> _32n & U32_MASK64)
  };
  return {
    h: Number(n >> _32n & U32_MASK64) | 0,
    l: Number(n & U32_MASK64) | 0
  };
}

exports.fromBig = fromBig;

function split(lst) {
  var le = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var Ah = new Uint32Array(lst.length);
  var Al = new Uint32Array(lst.length);

  for (var i = 0; i < lst.length; i++) {
    var _fromBig = fromBig(lst[i], le),
        h = _fromBig.h,
        l = _fromBig.l;

    var _ref = [h, l];
    Ah[i] = _ref[0];
    Al[i] = _ref[1];
  }

  return [Ah, Al];
}

exports.split = split;

var toBig = function toBig(h, l) {
  return BigInt(h >>> 0) << _32n | BigInt(l >>> 0);
};

exports.toBig = toBig; // for Shift in [0, 32)

var shrSH = function shrSH(h, l, s) {
  return h >>> s;
};

exports.shrSH = shrSH;

var shrSL = function shrSL(h, l, s) {
  return h << 32 - s | l >>> s;
};

exports.shrSL = shrSL; // Right rotate for Shift in [1, 32)

var rotrSH = function rotrSH(h, l, s) {
  return h >>> s | l << 32 - s;
};

exports.rotrSH = rotrSH;

var rotrSL = function rotrSL(h, l, s) {
  return h << 32 - s | l >>> s;
};

exports.rotrSL = rotrSL; // Right rotate for Shift in (32, 64), NOTE: 32 is special case.

var rotrBH = function rotrBH(h, l, s) {
  return h << 64 - s | l >>> s - 32;
};

exports.rotrBH = rotrBH;

var rotrBL = function rotrBL(h, l, s) {
  return h >>> s - 32 | l << 64 - s;
};

exports.rotrBL = rotrBL; // Right rotate for shift===32 (just swaps l&h)

var rotr32H = function rotr32H(h, l) {
  return l;
};

exports.rotr32H = rotr32H;

var rotr32L = function rotr32L(h, l) {
  return h;
};

exports.rotr32L = rotr32L; // Left rotate for Shift in [1, 32)

var rotlSH = function rotlSH(h, l, s) {
  return h << s | l >>> 32 - s;
};

exports.rotlSH = rotlSH;

var rotlSL = function rotlSL(h, l, s) {
  return l << s | h >>> 32 - s;
};

exports.rotlSL = rotlSL; // Left rotate for Shift in (32, 64), NOTE: 32 is special case.

var rotlBH = function rotlBH(h, l, s) {
  return l << s - 32 | h >>> 64 - s;
};

exports.rotlBH = rotlBH;

var rotlBL = function rotlBL(h, l, s) {
  return h << s - 32 | l >>> 64 - s;
};

exports.rotlBL = rotlBL; // JS uses 32-bit signed integers for bitwise operations which means we cannot
// simple take carry out of low bit sum by shift, we need to use division.

function add(Ah, Al, Bh, Bl) {
  var l = (Al >>> 0) + (Bl >>> 0);
  return {
    h: Ah + Bh + (l / Math.pow(2, 32) | 0) | 0,
    l: l | 0
  };
}

exports.add = add; // Addition with more than 2 elements

var add3L = function add3L(Al, Bl, Cl) {
  return (Al >>> 0) + (Bl >>> 0) + (Cl >>> 0);
};

exports.add3L = add3L;

var add3H = function add3H(low, Ah, Bh, Ch) {
  return Ah + Bh + Ch + (low / Math.pow(2, 32) | 0) | 0;
};

exports.add3H = add3H;

var add4L = function add4L(Al, Bl, Cl, Dl) {
  return (Al >>> 0) + (Bl >>> 0) + (Cl >>> 0) + (Dl >>> 0);
};

exports.add4L = add4L;

var add4H = function add4H(low, Ah, Bh, Ch, Dh) {
  return Ah + Bh + Ch + Dh + (low / Math.pow(2, 32) | 0) | 0;
};

exports.add4H = add4H;

var add5L = function add5L(Al, Bl, Cl, Dl, El) {
  return (Al >>> 0) + (Bl >>> 0) + (Cl >>> 0) + (Dl >>> 0) + (El >>> 0);
};

exports.add5L = add5L;

var add5H = function add5H(low, Ah, Bh, Ch, Dh, Eh) {
  return Ah + Bh + Ch + Dh + Eh + (low / Math.pow(2, 32) | 0) | 0;
};

exports.add5H = add5H;